import * as Redux from 'redux';
import { HashMap } from '../constants';
import { SimManagementError } from '../models/Errors';
import { LoadCommandStocksPayload } from '../models/payload/loadRequests';
import { SimCommandCreate } from '../models/simCommand';
import {
  ENSURE_COMMAND_STOCKS,
  LOAD_COMMAND_STOCKS,
  LOAD_COMMAND_STOCKS_FAILURE,
  LOAD_COMMAND_STOCKS_PENDING,
  LOAD_COMMAND_STOCKS_SUCCESS,
} from './actionTypes';
import { Action, ActionMeta } from './commonActions';

/**
 * Action which loads the available commands from the server if required.
 * @param payload A comma-separated list of identifiers for the currently selected stock
 */
export function ensureCommandStocks(payload: LoadCommandStocksPayload): Action<LoadCommandStocksPayload> {
  return {
    type: ENSURE_COMMAND_STOCKS,
    payload,
  };
}

/**
 * Action which loads the available command stocks from the server.
 * @param payload A comma-separated list of identifiers for the currently selected stock
 */
export function loadCommandStocks(payload: LoadCommandStocksPayload): Action<LoadCommandStocksPayload> {
  return {
    type: LOAD_COMMAND_STOCKS,
    payload,
  };
}

/**
 * Action which sets the load status of the command types to pending.
 * @param payload A comma-separated list of identifiers for the currently selected stock
 */
export function loadCommandStocksPending(payload: LoadCommandStocksPayload): Action<LoadCommandStocksPayload> {
  return {
    type: LOAD_COMMAND_STOCKS_PENDING,
    payload,
  };
}

/**
 * Action which handles when the command stocks are successfully loaded.
 * @param commandTypes The command types payload
 * @param meta The meta information about the request
 */
export function loadCommandStocksSuccess(
  payload: HashMap<SimCommandCreate>,
  meta: LoadCommandStocksPayload,
): ActionMeta<HashMap<SimCommandCreate>, LoadCommandStocksPayload> {
  meta.selectedStockSerialNumbers.sort();
  return {
    type: LOAD_COMMAND_STOCKS_SUCCESS,
    payload,
    meta,
  };
}

/**
 * Action which handles when there is a failure to load the command stocks
 * @param selectedStockIds A comma-separated list of identifiers for the currently selected stock
 * @param error The error.
 */
export function loadCommandStocksFailure(
  error: SimManagementError,
  meta: LoadCommandStocksPayload,
): ActionMeta<SimManagementError, LoadCommandStocksPayload> {
  return {
    error: true,
    type: LOAD_COMMAND_STOCKS_FAILURE,
    payload: error,
    meta,
  };
}
